import { CopyOutlined } from '@ant-design/icons';
import { message,Tooltip } from 'antd';

const MobileCopyBox = () => {
  const text = '  +91 81003 76761 ';
  const mobileNumber = '+918100376761';

  const copyToClipboard = () => {
    navigator.clipboard.writeText(mobileNumber);
    message.success('Mobile number copied!');
  };

  return (
    <div className="relative bg-[#f5f5f5] rounded-md border p-4 font-mono text-sm text-gray-800 cursor-pointer" onClick={copyToClipboard}>
      <Tooltip title="Copy">
        <button
          onClick={copyToClipboard}
          className="absolute top-2 right-2 text-gray-500 hover:text-black"
        >
          <CopyOutlined />
        </button>
      </Tooltip>
      <pre className="whitespace-pre-wrap break-all">{text}</pre>
    </div>
  );
};

export default MobileCopyBox;
